<template>

<NetworkStatus v-if="isOffline" />
<div v-else>  
  <!--========================= modal add group =================================== -->

  <div v-if="showModal" class="modal-backdrop show" @click="showModal = false"></div>
  <div v-if="showModal" class="modal show" style="display: block;">
    <div class="modal-dialog">
      <div class="card">
        <div class="modal-content">
          <div
            class="modal-header border-0"

          >
            <h5 class="modal-title"></h5>
            <button
              type="button"
              class="btn-close"
              @click="showModal = false"
            ></button>
          </div>
          <div class="modal-body text-center pt-4 pb-4">
            <div class="text">
              <i
                style="color: #f1c40f; font-size: 70px"
                class="bi bi-check2-circle"
              ></i>

              <h6 class="text-xl ps-4 mb-3 font-weight-bolder">
                {{ $t("newpayment.modal_title") }}
              </h6>

              <span class="nav-link-text"> {{ $t("newpayment.modal_p") }}</span>
            </div>

            <div class="row mt-4">
              <div class="col-md-6 text-end">
                <argon-button
                  color="success"
                  size="xl"
                  variant="outline"
                  @click="redirectinstallment"
                  style="width: 200px; height: 50px; padding-top: 15px"
                  ><i class="fas fa-plus me-2"></i>
                  {{ $t("newpayment.modal_button_installment") }}
                </argon-button>
              </div>

              <div class="col-md-6 text-start">
                <argon-button
                  color="success"
                  @click="hideModal"
                  :disabled="loading"
                  style="width: 200px; height: 50px; padding-top: 15px"
                >
                  <span v-if="!loading"
                    ><i class="fas fa-plus me-2"></i>
                    {{ $t("newpayment.modal_button_group") }}</span
                  >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </argon-button>
              </div>
            </div>
          </div>
          <div
            class="modal-footer border-0 mt-6 pb-5 mb-1"

          >
            <button
              type="button"
              class="btn bg-transparent"
              @click="Cancel"
              style="width: 150px; height: 50px; padding-top: 15px; border:1px solid rgba(250, 250,250,0.4); margin-right: 110px;"
            >
              {{ $t("button.cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-----------------------------fin modal -------------------->

  <div class="p-5 container-fluid" style="margin-bottom: 120px">
    <div class="description">
      <div class="student-form-title">
        <p class="text-center" v-html="$t('newpayment.title')"></p>
      </div>
      <div class="student-form">
        <form class="form col-xs-7 col-md-6 col-lg-7">
          <!-- Nom du groupe : librement choisi par l'établissement -->
          <div class="mb-4">
            <p style="transform: translateY(10px)" class="small">
              {{ $t("newpayment.group_name") }}
            </p>
            <input
              type="text"
              class="form-control"
              style="height: 50px"
              v-model="group_name"
              :placeholder="$t('newpayment.group_name_placeholder')"
            />
          </div>

          <!--
            Sélection des niveaux du groupe.

            Un groupe de paiement s'applique à des NIVEAUX entiers : toutes les
            6ème partagent les mêmes frais, qu'il s'agisse de la 6ème A ou de
            la 6ème B. On coche donc directement les niveaux, ce qui
            correspond au champ `grade_code_list` attendu par l'API.
          -->
          <div class="mb-4">
            <div class="d-flex align-items-center justify-content-between">
              <p class="small mb-0">{{ $t("newpayment.select_grades") }}</p>
              <span class="selected-count" :class="{ 'is-empty': !selectedCount }">
                {{ $t("newpayment.selected_count", { count: selectedCount }) }}
              </span>
            </div>
            <p class="text-xs mb-2" style="opacity: 0.55">
              {{ $t("newpayment.select_grades_hint") }}
            </p>

            <div class="grade-picker" v-if="GRADE_CODE.length">
              <label
                class="grade-chip"
                :class="{ active: isGradeSelected(grade) }"
                v-for="grade in GRADE_CODE"
                :key="grade.id || grade.code"
              >
                <input
                  type="checkbox"
                  :checked="isGradeSelected(grade)"
                  @change="toggleGrade(grade)"
                />
                <span class="grade-chip-name">{{ grade.name }}</span>
                <span class="grade-chip-count">{{ classCountLabel(grade) }}</span>
              </label>
            </div>

            <p class="text-xs" style="opacity: 0.55" v-else>
              {{ $t("newpayment.no_grade") }}
            </p>
          </div>

          <!--
            Spécialité : facultative.
            Laissée sur « Toutes les spécialités », le groupe couvre chaque
            classe des niveaux cochés. Renseignée, il ne s'applique qu'aux
            classes de cette spécialité — utile pour distinguer, par exemple,
            des frais propres à une série.
          -->
          <div class="mb-4" v-if="SPECIALITY_CODE.length">
            <p style="transform: translateY(10px)" class="small">
              {{ $t("newpayment.speciality_optional") }}
            </p>
            <select class="form-control" style="height: 50px" v-model="speciality_code">
              <option value="">{{ $t("newpayment.all_specialities") }}</option>
              <option
                v-for="item in SPECIALITY_CODE"
                :key="item.code || item.short_name"
                :value="item.short_name"
              >
                {{ item.short_name }} - {{ item.title }}
              </option>
            </select>
          </div>

          <div class="row p-1 mt-5 g-3">
             
            <div class="col-lg-6">
              <argon-button
                size="lg"
                color="success"
                full-width
                @click="createconfig"
                :clickEvent="button"
                :disabled="loading"
              >
                <span>{{ $t("button.save") }}</span>
              </argon-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton";
import { createconfig, getGrades, getSpeciality } from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import NetworkStatus from "@/views/components/NetworkStatus.vue";

export default {
  name: "Config-Form",
  components: { ArgonButton, NetworkStatus },
  data() {
    return {
      /* Nom libre du groupe (« Premier groupe », « Terminales scientifiques »…) */
      group_name: "",
      /* Spécialité du groupe ; vide = toutes spécialités. */
      speciality_code: "",
      SPECIALITY_CODE: [],
      /* Codes des niveaux cochés (« SIX », « CIN »…). */
      selectedGrades: [],
      loading: false,
      button: "",
      successMessage: "",
      GRADE_CODE: [],
      showModal: false,
      createdConfigId: null,
      buttonActive: false,
      showConfirmation: false,
      isOffline: false,  
      apiError: false,
    };
  },





  computed: {
    selectedCount() {
      return this.selectedGrades.length;
    },
  },

  async mounted() {
    // Initialiser l'état de connexion au montage
    await this.updateOnlineStatus();
    await this.getData();

    // Ajouter les event listeners pour les changements de réseau
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    this.intervalId = setInterval(this.checkInternetConnection, 1000);


    // Charger les données initiales
    if (!this.isOffline) {
      await this.getData();
    }
  },

  beforeUnmount() {
    // Nettoyer les event listeners existants
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  methods: {

    async updateOnlineStatus() {
      // Vérifier si le navigateur est en ligne
      if (navigator.onLine) {
        try {
          // Vérifier si les API sont accessibles
          await this.checkConnection();
          this.isOffline = false; // Tout fonctionne, on est en ligne
        } catch (error) {
          console.error("Error checking connection:", error);
          this.isOffline = true; // Les API ne répondent pas, on est hors ligne
        }
      } else {
        // Pas de connexion internet détectée
        this.isOffline = true;
      }
    },

    async checkConnection() {
      try {
        // Essayer les deux appels API
        await Promise.all([
        getGrades()
           
        ]);
        this.apiError = false; // Les API répondent correctement
      } catch (error) {
        console.error("API Error:", error);
        this.apiError = true; // Les API ne répondent pas
      }
    },

    // Méthode Cancel mise à jour
    Cancel() {
      this.showModal = false;
      this.$nextTick(() => {
        this.$router.push({
          name: "payment-config",
        });
      });
    },

    // Méthode hideModal mise à jour
    hideModal() {
      this.showModal = false;
      setTimeout(() => {
        window.location.reload(true);
        this.configApplied = true;
      }, 150);
    },

    resetForm() {
      this.group_name = "";
      this.selectedGrades = [];
      this.speciality_code = "";
    },

    // Replace the getData method with this updated version
    async getData() {
      try {
        // Get grades
        let grades = await getGrades();
        this.GRADE_CODE = (grades && grades.data) || [];

        // Vide par défaut : présélectionner une spécialité restreindrait le
        // groupe sans que l'utilisateur l'ait demandé.
        let specialities = await getSpeciality();
        this.SPECIALITY_CODE = (specialities && specialities.data) || [];
      } catch (error) {
        console.error("Error fetching data:", error);
        this.GRADE_CODE = [];
        this.SPECIALITY_CODE = [];
      }
    },

    /** Code d'un niveau, tel qu'attendu par l'API. */
    gradeCode(grade) {
      return grade.code || grade.name;
    },
    isGradeSelected(grade) {
      return this.selectedGrades.includes(this.gradeCode(grade));
    },
    toggleGrade(grade) {
      const code = this.gradeCode(grade);
      const index = this.selectedGrades.indexOf(code);
      if (index === -1) this.selectedGrades.push(code);
      else this.selectedGrades.splice(index, 1);
    },
    /** Nombre de classes du niveau, à titre indicatif. */
    /** Nombre de classes du niveau, à titre indicatif. */
    classCountLabel(grade) {
      const count = (grade.classrooms || []).length;
      return this.$t("newpayment.class_count", { count });
    },

    redirectinstallment() {
      this.showModal = false;
      this.$nextTick(() => {
        this.$router.push({
          name: "detail-config",
          params: { id: this.createdConfigId },
        });
      });
    },

    async createconfig() {
      try {
        if (this.loading) {
          // Si la soumission est déjà en cours, ne rien faire
          return;
        }
        this.loading = true;
        this.button = "disabled";

        let data = {
          name: this.group_name,
          grade_code_list: [...this.selectedGrades],
          // Vide = toutes les spécialités des niveaux cochés.
          speciality_code: this.speciality_code || "",
          installment_list: [],
        };

        if (!this.selectedGrades.length) {
          if (!this.showConfirmation) {
            this.showConfirmation = true;
            const message = this.$t("newpayment.select_at_least_one");
            toast.error(message, {
              autoClose: 3000,
            });
            setTimeout(() => {
              this.showConfirmation = false;
            }, 4000);
          }
          return;
        }

        let res = await createconfig(data);

        if (!navigator.onLine) {
          const message = this.$t("message.notinternet");
          toast.error(message, {
            autoClose: 3000,
          });
        } else if (res.status === 404) {
          const message = this.$t("message.user404");
          toast.error(message, {
            autoClose: 3000,
          });
        } else if (res.status === 201) {
          this.createdConfigId = res.data.id;

          this.showModal = true;

          if (!this.showConfirmation) {
            this.showConfirmation = true;
            setTimeout(() => {
              this.showConfirmation = false;
            });
          }
        }
      } catch (error) {
        console.error(error);

        if (error.response && error.response.status === 404) {
          toast.error("User not found. Please check the provided information", {
            autoClose: 3000,
          });
        } else {
          const message = this.$t("message.duplicateConfig");
          toast.error(message, {
            autoClose: 3000,
          });
        }
      } finally {
        this.loading = false;
        this.button = "";
      }
    },
  },
  
  beforeMount() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.student-form {
  display: flex;
  justify-content: center;
  margin-top: 5vh;
}

.student-form-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info {
  color: #dc3545;
  font-size: 14px;
  margin-left: 5px;
}

.required {
  border-color: #f60000 !important;
}

/* --- Sélecteur de niveaux ----------------------------------------------- */

.grade-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 14px;
  max-height: 300px;
  overflow-y: auto;
}

/* La case à cocher est masquée : c'est toute la pastille qui sert de cible,
   plus confortable à viser qu'un petit carré. */
.grade-chip {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  padding: 9px 16px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 0;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.grade-chip input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.grade-chip:hover {
  border-color: rgba(46, 206, 191, 0.5);
}

.grade-chip.active {
  border-color: #2ecebf;
  background: rgba(46, 206, 191, 0.12);
  color: #2ecebf;
}

.grade-chip-name {
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.2;
}

.grade-chip-count {
  font-size: 10.5px;
  opacity: 0.55;
  line-height: 1.2;
}

.selected-count {
  font-size: 11px;
  color: #2ecebf;
  font-variant-numeric: tabular-nums;
}

.selected-count.is-empty {
  color: inherit;
  opacity: 0.45;
}
</style>